import Api from 'src/api/Base'

class DeleteShelfProductLayout extends Api {
  requestUrl = `/api/ShelfProductLayout/${this.getParams().id}`

  method = 'DELETE'
}

export default DeleteShelfProductLayout
